import { Box, Typography, Avatar } from "@mui/material";
import { styled } from "@mui/system";
import Button from "@mui/material/Button";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import carousel styles
import ProfileTabs from "../common/ProfileTabs";
import { ROUTE_TAKE_TEST } from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import SeeviHeader from "../common/SeeviHeader";

const Avatar1 = styled(Avatar)({
  width: "51px",
  height: "51px",
});

const StyledTextBox = styled(Box)({
  fontSize: "16px",
  backgroundColor: "#ffffff",
  borderRadius: "10px",
  paddingTop: "8px",
  paddingBottom: "8px",
  fontFamily: "Poppins, sans-serif",
  fontWeight: "400",
  color: "#1F2235",
  lineHeight: "1.5",
});

const Profiler = () => {
  const navigate = useNavigate();

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" bgcolor="#eeeeee" width="100%">
      <SeeviHeader />
      <ProfileTabs />

      <Box display="flex" flexDirection="column" alignItems="left" fontSize="14px" fontWeight="500" color="#757575">
        <Box display="flex" alignItems="center" sx={{ px: 2, backgroundColor: "#eeeeee" }}>
          <Avatar1 src="/images/avatar-one.png" alt="Avatar" />
          <StyledTextBox px={2} ml={1} mt={2}>
            <Box>
              <Typography className="custom-typography-video">
                We believe the right personality shines in the right culture. There is no perfect candidate or company,
                only a perfect match.
              </Typography>
            </Box>
          </StyledTextBox>
        </Box>

        <Box display="flex" alignItems="center" sx={{ px: 2, backgroundColor: "#eeeeee" }} mt={2}>
          <StyledTextBox px={2} sx={{ backgroundColor: "#E6E4FE" }}>
            <Typography
              sx={{ color: "#4242AD", fontWeight: "600", fontSize: "25px" }}
              className="custom-typography-video"
            >
              WorkWise Personality Profiler
            </Typography>
            <Typography className="custom-typography-video">
              Our panel of expert psychologists has thoroughly examined role requirements across various functions and
              industries to carefully craft 8 personality archetypes, which you uncover through this simple test.
            </Typography>
          </StyledTextBox>
        </Box>

        {/* <Box display="flex" alignItems="center" sx={{ backgroundColor: "#eeeeee" }} pl={2.5} pr={5} mt={2}>
          <img src="images/crafting-video-1.png" alt="crafting-video" width="100%" />
        </Box> */}

        <Box display="flex" alignItems="center" sx={{ backgroundColor: "#eeeeee", px: 2 }} mt={2}>
          <StyledTextBox px={2} sx={{ backgroundColor: "#ffffff" }}>
            <Typography
              sx={{ color: "#4242AD", fontWeight: "600", fontSize: "25px" }}
              className="custom-typography-video"
            >
              👉 Remember
            </Typography>
            <Box className="custom-typography-video">
              <ul style={{ paddingLeft: 0, listStyleType: "none", margin: 0 }}>
                <li>
                  <span style={{ display: "inline-block", width: "5px", marginRight: "10px" }}>•</span>These are
                  situational questions with no right or wrong answers.
                </li>
                <li>
                  <span style={{ display: "inline-block", width: "5px", marginRight: "10px" }}>•</span>Being true while
                  responding, ensures that the WorkWise Personality-Profiler correctly identifies your Personality Type.
                </li>
                <li>
                  <span style={{ display: "inline-block", width: "5px", marginRight: "10px" }}>•</span>WorkWise
                  Personality-Profiler outlines career paths that you are naturally adept for.
                </li>
                <li>
                  <span style={{ display: "inline-block", width: "5px", marginRight: "10px" }}>•</span>You get insights
                  into the unique skills and traits that you bring to the table.
                </li>
              </ul>
            </Box>
          </StyledTextBox>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          p={2}
          bgcolor="#ffffff"
          sx={{ borderRadius: "0px", marginTop: "20px" }}
        >
          <Box display="flex">
            <Button
              sx={{
                backgroundColor: "white",
                borderRadius: "99px",
                fontSize: "16px",
                textTransform: "capitalize",
                width: "25%",
                color: "#000000",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
              variant="contained"
              size="small"
              style={{ padding: "15px 40px" }}
              className="w-100 mt-2 btn-pad"
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
            <Box flexGrow={1}></Box>
            <Button
              sx={{
                backgroundColor: "#756DE9",
                borderRadius: "99px",
                fontSize: "16px",
                textTransform: "capitalize",
                width: "70%",
                paddingY: "15px",
                paddingX: 0,
                "&:hover": {
                  backgroundColor: "#756DE9",
                },
              }}
              variant="contained"
              size="small"
              className="w-100 mt-2 btn-pad"
              onClick={() => navigate(ROUTE_TAKE_TEST)}
            >
              Let&apos;s Start
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Profiler;
